import React from 'react'

const Menu = ({ color = '#DC7B19', size = '5' }) => {
  return (
    <svg
      className={`h-${size} w-${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.25 18.8748V17.3748H6.25V10.1248C6.25 8.75814 6.671 7.5538 7.513 6.5118C8.35433 5.47047 9.43333 4.7998 10.75 4.4998V3.7998C10.75 3.4498 10.871 3.1538 11.113 2.9118C11.3543 2.67047 11.65 2.5498 12 2.5498C12.35 2.5498 12.6457 2.67047 12.887 2.9118C13.129 3.1538 13.25 3.4498 13.25 3.7998V4.4998C14.5667 4.7998 15.646 5.47047 16.488 6.5118C17.3293 7.5538 17.75 8.75814 17.75 10.1248V17.3748H19.75V18.8748H4.25ZM12 21.7998C11.5 21.7998 11.075 21.6248 10.725 21.2748C10.375 20.9248 10.2 20.4998 10.2 19.9998H13.8C13.8 20.4998 13.625 20.9248 13.275 21.2748C12.925 21.6248 12.5 21.7998 12 21.7998ZM7.75 17.3748H16.25V10.1248C16.25 8.94147 15.8373 7.93714 15.012 7.1118C14.1873 6.28714 13.1833 5.8748 12 5.8748C10.8167 5.8748 9.81267 6.28714 8.988 7.1118C8.16267 7.93714 7.75 8.94147 7.75 10.1248V17.3748Z"
        fill={color}
      />
      <circle cx="20" cy="4" r="3.5" fill="#DC7B19" stroke="white" />
    </svg>
  )
}

export default Menu
